<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-1"><a id="_idTextAnchor002"></a>After the Applause </h1>
<p class="Verse-first">Back from the war</p>
<p class="Verse-main">The non-war </p>
<p class="Verse-main">But I’m still a veteran </p>
<p class="Verse-main">You look down to the floor</p>
<p class="Verse-new">I served my country </p>
<p class="Verse-main">My sacrifice was given </p>
<p class="Verse-main">Which you didn’t acknowledge</p>
<p class="Verse-main">And you’re not forgiven </p>
<p class="Verse-new">The world looks strange </p>
<p class="Verse-main">Through the same eyes </p>
<p class="Verse-main">So many finals </p>
<p class="Verse-main">So many silent goodbyes</p>
<p class="Verse-new">There’s no more rainbows </p>
<p class="Verse-main">Amongst the blue skies </p>
<p class="Verse-main">There’s no more shown gratitude </p>
<p class="Verse-main">Seems everyone has reached their prize </p>
<p class="Verse-new">But everything changed for me</p>
<p class="Verse-main">In such a short time </p>
<p class="Verse-main">But not to be seen </p>
<p class="Verse-main">Is the largest of crimes</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB5.vue?5f55b998